<p-dialog *ngIf="showDialog" [resizable]="false" [(visible)]="showDialog"
  (visibleChange)="showDialogChange.emit($event)" [modal]="true" [draggable]="false" appendTo="body">
  <ng-template pTemplate="header">
    <h3>OIB servis</h3>
  </ng-template>

  <div *ngIf="loadingOib" class="flex justify-content-center p-3">
    <p-progressSpinner strokeWidth="4" [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
  </div>

  <div *ngIf="!loadingOib" class="field md:flex gap-2 align-items-center">
    <label for="oib-input" class="property-label">OIB: </label>

    <input id="oib-input" class="p-inputtext p-component" [formControl]="oib" [readonly]="oibReadonly" />

    <p-button [disabled]="!oib.valid" (onClick)="searchClicked.emit()" label="Pretraži"></p-button>
  </div>

  <div *ngIf="!loadingOib && dirty && !!!oibResponse">
    Nije pronađen nijedan zapis u OIB servisu!
  </div>
  <p-message *ngIf="!loadingOib && fetchError" severity="error" [text]="fetchError"></p-message>
  <div *ngIf="!loadingOib && oibResponse">
    <div class="flex align-items-center gap-3">
      <p-button [disabled]="!oibResponse || !oib.value || oib.invalid"
        (onClick)="applyClicked.emit()">Primijeni</p-button>
      <h4 *ngIf="oibResponse.naziv">{{ oibResponse.naziv }}</h4>
      <h4 *ngIf="oibResponse.ime && oibResponse.prezime">{{ oibResponse.ime }} {{ oibResponse.prezime }}</h4>
    </div>

    <p-fieldset legend="Detalji" [toggleable]="true">
      <ul>
        <li class="md:flex">
          <strong class="w-13rem">OIB:</strong>
          <p>{{ oibResponse.oib }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.mb">
          <strong class="w-13rem">MB:</strong>
          <p>{{ oibResponse.mb }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.mbs">
          <strong class="w-13rem">MBS:</strong>
          <p>{{ oibResponse.mbs }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.naziv">
          <strong class="w-13rem">Naziv:</strong>
          <p>{{ oibResponse.naziv }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.skraceniNaziv">
          <strong class="w-13rem">Skraćeni naziv:</strong>
          <p>{{ oibResponse.skraceniNaziv }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.ime">
          <strong class="w-13rem">Ime:</strong>
          <p>{{ oibResponse.ime }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.prezime">
          <strong class="w-13rem">Prezime:</strong>
          <p>{{ oibResponse.prezime }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.adresa">
          <strong class="w-13rem">Adresa:</strong>
          <p>
            <span *ngIf="oibResponse.adresa.ulica">{{ oibResponse.adresa.ulica }}</span>
            <span *ngIf="oibResponse.adresa.kucniBroj"> {{ oibResponse.adresa.kucniBroj }}</span>
            <span *ngIf="oibResponse.adresa.kucniBrojDodatak">{{ oibResponse.adresa.kucniBrojDodatak }}</span>
            <span *ngIf="oibResponse.adresa.naselje">, {{ oibResponse.adresa.naselje }}</span>
            <span *ngIf="oibResponse.adresa.drzava">, {{ oibResponse.adresa.drzava }}</span>
          </p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.sifraGlavneDjelatnosti">
          <strong class="w-13rem">Šifra glavne djelatnosti:</strong>
          <p>{{ oibResponse.sifraGlavneDjelatnosti }}</p>
        </li>
        <li class="md:flex" *ngIf="oibResponse.datumOsnivanja">
          <strong class="w-13rem">Datum osnivanja:</strong>
          <p>{{ oibResponse.datumOsnivanja }}</p>
        </li>
      </ul>
    </p-fieldset>
  </div>
  <p-message *ngIf="!loadingOib && applyError" severity="error" [text]="applyError"></p-message>

  <ng-template pTemplate="footer">
    <div class="flex">
      <p-button (onClick)="onClose()">Zatvori</p-button>
    </div>
  </ng-template>
</p-dialog>